module.exports = __webpack_public_path__ + "media/newstyle/images/icon-estantevirtual-4106eeda19d1cbfe3d144d81b250ca88.svg";